export const UPDATE_NODE = 'UPDATE_NODE';
export const CREATE_NODE = 'CREATE_NODE';

export function create(info) {
  return {
    type: CREATE_NODE,
    info,
  };
}
  
export function update(id, params) {
  return {
    type: UPDATE_NODE,
    id,
    params,
  };
}



// WEBPACK FOOTER //
// ./src/actions/node.js